var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIconmodal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 0C4.93263 0 0 4.93263 0 11C0 17.0674 4.93263 22 11 22C17.0674 22 22 17.0674 22 11C22 4.93263 17.0674 0 11 0ZM17.16 12.0421H15.4926L13.8716 15.2842C13.6632 15.6316 13.3158 15.8632 12.9221 15.8632C12.5284 15.8632 12.1579 15.6316 11.9958 15.2842L9.0779 9.51789L8.10526 11.4632C7.92 11.8105 7.57263 12.0421 7.17895 12.0421H4.86316C4.28421 12.0421 3.82105 11.5789 3.82105 11C3.82105 10.4211 4.28421 9.95789 4.86316 9.95789H6.53053L8.15158 6.71579C8.49895 6.02105 9.65684 6.02105 10.0042 6.71579L12.8989 12.4821L13.8947 10.5137C14.08 10.1663 14.4274 9.93474 14.8211 9.93474H17.1368C17.7158 9.93474 18.1789 10.3979 18.1789 10.9768C18.1789 11.5558 17.7389 12.0421 17.16 12.0421Z",
    fill: "#8D90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconmodal);
export default __webpack_public_path__ + "static/media/statusIconmodal.2083b312bb152ddbbe1006b86dc9bdf1.svg";
export { ForwardRef as ReactComponent };